import { useState, useEffect, useCallback } from 'react';
import photo1 from '../assets/photoSH12.jpeg';
import photo2 from '../assets/photoSH10.jpeg';

const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      subtitle: 'Local Manufacturing • Global Technology',
      title: 'Produk Berkualitas',
      titleHighlight: 'Standar Internasional',
      description: 'PT Shuanghui Power Indonesia merupakan bagian dari Shuanghui Power Group, yang menyediakan manufaktur lokal sistem switchgear serta pasokan terintegrasi peralatan ketenagalistrikan global di Indonesia.',
      backgroundImage: photo1
    },
    {
      subtitle: 'Tertarik menjadi pengalanggan kami',
      title: 'Solusi Kelistrikan Terpercaya',
      titleHighlight: 'Industri Indonesia',
      description: 'Didukung dengan teknologi terkini dan proses produksi yang terstandarisasi, kami menghadirkan produk kelistrikan yang andal dan efisien.',
      backgroundImage: photo2
    }
  ];

  const nextSlide = useCallback(() => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  }, [slides.length]);

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  useEffect(() => {
    const interval = setInterval(nextSlide, 5000);
    return () => clearInterval(interval);
  }, [nextSlide]);

  return (
    <section className="hero" id="home">
      {/* Carousel Slides */}
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`hero-slide ${index === currentSlide ? 'active' : ''}`}
        >
          <div
            className="hero-background"
            style={{ backgroundImage: `url(${slide.backgroundImage})` }}
          />
          <div className="hero-overlay"></div>
        </div>
      ))}

      <div className="hero-content-wrapper">
        <div className="container">
          <div className="hero-content-center">
            <span className="hero-subtitle">{slides[currentSlide].subtitle}</span>

            <div className="hero-divider">
              <span></span>
              <span className="divider-icon">*</span>
              <span></span>
            </div>

            <h1 className="hero-title-main">
              {slides[currentSlide].title}<br />
              untuk <span>{slides[currentSlide].titleHighlight}</span>
            </h1>

            <p className="hero-description-center">
              {slides[currentSlide].description}
            </p>

            <div className="hero-buttons-center">
              <a href="#products" className="btn btn-primary">Lihat Produk</a>
              <a href="#about" className="btn btn-outline">Tentang Kami</a>
            </div>
          </div>
        </div>
      </div>

      {/* Carousel Navigation Arrows */}
      <button className="hero-nav hero-nav-prev" onClick={prevSlide} aria-label="Previous slide">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polyline points="15 18 9 12 15 6"></polyline>
        </svg>
      </button>
      <button className="hero-nav hero-nav-next" onClick={nextSlide} aria-label="Next slide">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polyline points="9 18 15 12 9 6"></polyline>
        </svg>
      </button>

      {/* Article Overview Sidebar */}
      <div className="hero-articles-sidebar">
        <div className="hero-articles-header">
          <span className="hero-articles-label">Artikel Terbaru</span>
        </div>
        <div className="hero-articles-list">
          <a href="#article-1" className="hero-article-item">
            <div className="hero-article-date">
              <span className="date-day">15</span>
              <span className="date-month">Jan</span>
            </div>
            <div className="hero-article-content">
              <h4>Panduan Memilih Switchgear yang Tepat</h4>
              <p>Tips memilih switchgear sesuai kebutuhan industri Anda</p>
            </div>
          </a>
          <a href="#article-2" className="hero-article-item">
            <div className="hero-article-date">
              <span className="date-day">08</span>
              <span className="date-month">Jan</span>
            </div>
            <div className="hero-article-content">
              <h4>Standar Keamanan Panel Listrik</h4>
              <p>Memahami standar SNI dan IEC untuk instalasi</p>
            </div>
          </a>
          <a href="#article-3" className="hero-article-item">
            <div className="hero-article-date">
              <span className="date-day">02</span>
              <span className="date-month">Jan</span>
            </div>
            <div className="hero-article-content">
              <h4>Maintenance Rutin Switchgear</h4>
              <p>Jadwal perawatan untuk performa optimal</p>
            </div>
          </a>
        </div>
        <a href="#articles" className="hero-articles-more">
          Lihat Semua Artikel
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </a>
      </div>

      {/* Carousel Dots */}
      <div className="hero-dots">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`hero-dot ${index === currentSlide ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>

      {/* Stats Bar at Bottom */}
      <div className="hero-stats-bar">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-item">
              <h3>500+</h3>
              <p>Proyek Selesai</p>
            </div>
            <div className="stat-item">
              <h3>100+</h3>
              <p>Klien Puas</p>
            </div>
            <div className="stat-item">
              <h3>10+</h3>
              <p>Tahun Pengalaman</p>
            </div>
            <div className="stat-item">
              <h3>50+</h3>
              <p>Tim Profesional</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
